import { Injectable, isDevMode } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { BehaviorSubject } from 'rxjs';
// import { Analytics } from '../analytics';

export interface CurrentVariations {
	enabledVariations: any,
	enabledVariationsList: any,
	enabledExperiments: any,
}

@Injectable({
	providedIn: 'root'
})
export class AnalyticsService {

	// private currentQuestion: string;
	// private analytics: any;
	public currentUrl = '';
	private enabledVarations : any = {};
	private enabledVarationsList : any = [];
	private enabledExperiments: any = [];
	private experimentsSubject: BehaviorSubject<CurrentVariations> = new BehaviorSubject(
		{
			enabledVariations: this.enabledVarations,
			enabledVariationsList: this.enabledVarationsList,
			enabledExperiments: this.enabledExperiments
		}
	);

	constructor(private router: ActivatedRoute, private locationService: Location) {
		let global_window = (window as any);
		console.log('matomo tests', global_window.matomo_ab);
		//Track enabled variations
		//Get experiments when Matomo loads second using the event listener
		window.addEventListener('ab-variation', (event) => this.trackVariationChangeEvent(event));
		//Get experiments when Matomo loads first using the global array
		if (typeof global_window.matomo_ab != "undefined" && global_window.matomo_ab) {
			//Tests loaded before the event was subscribed, run through them
			console.log('adding in tests added before event load', global_window.matomo_ab);
			global_window.matomo_ab.map((test) => this.trackVariationChange(test));
		}
		// this.analytics = new Analytics();
		this.currentUrl = '/communication' + this.locationService.path(true);
		//If we add different routes we may need to subscribe to router.url or something as well
		//when we upgrade angular we should be able to use the locationService.onUrlChange event instead
		this.router.queryParams.subscribe(params => this.trackUrlChange());
	}

	//Consume ab-variation custom event and track currently enabled variations
	trackVariationChangeEvent(event) {
		if (!event.detail || !event.detail.experimentName || !event.detail.variationName) {
			console.log('Analytics trackVariationChange called incorrectly', event);
			console.log('No event detail?', !event.detail);
			console.log('No event experimentName?', !event.detail.experimentName)
			console.log('No event variationName?', !event.detail.variationName);
			return;
		}
		this.trackVariationChange(event.detail);
	}

	trackVariationChange(change) {
		this.enabledVarations[change.variationName] = true;
		this.enabledVarationsList.push(change.variationName);
		let enabledExperiment = this.enabledExperiments.find((experiment) => experiment.experimentName === change.experimentName);
		if (enabledExperiment === undefined || enabledExperiment === null) {
			this.enabledExperiments.push({
				'experiment' : change.experimentName,
				'variation' : change.variationName
			});
		}
		console.log('enabled experiments', this.enabledExperiments);
		console.log('enabled variations', this.enabledVarations);
		console.log('enabled variations list', this.enabledVarationsList);
		this.experimentsSubject.next({
			enabledVariations: this.enabledVarations,
			enabledVariationsList: this.enabledVarationsList,
			enabledExperiments: this.enabledExperiments
		});
	}

	getExperiments() {
		return this.experimentsSubject.asObservable();
	}

	trackUrlChange() {
		let newUrl = '/communication' + this.locationService.path(true);
		if (this.currentUrl != newUrl) {
			var previousUrl = this.currentUrl;
			this.currentUrl = newUrl;
			let _paq = (window as any)._paq || [];
			if (_paq) {
				_paq.push(['setReferrerUrl', previousUrl]);
				_paq.push(['setCustomUrl', this.currentUrl]);
				_paq.push(['trackPageView']);
			} else {
				console.log('paq not found');
			}
			/*var data = {
				'setReferrerUrl': previousUrl,
				'setCustomUrl': this.currentUrl,
			};
			console.log('url change', data);*/
		}
	}

	trackQuestionShown(detail: string): void {
		// this.currentQuestion = detail;
		// this.analytics.track('question:shown', this.currentQuestion);
	}

	trackQuestionAnswered(): void {
		// this.analytics.track('question:answered:valid', this.currentQuestion);
	}

	trackQuestionAnsweredInvalid(): void {
		// this.analytics.track('question:answered:invalid', this.currentQuestion);
	}

	trackRedirect(path: string): void {
		// this.analytics.track('redirect', path);
	}

	trackEvent(eventCategory: string,
		eventAction: string,
		eventName: string|null = null,
		eventValue: string|null = null): void {
		let _paq = (window as any)._paq || [];
		if (eventName) {
			if (eventValue) {
				_paq.push(['trackEvent', eventCategory, eventAction, eventName, eventValue]);
			} else{
				_paq.push(['trackEvent', eventCategory, eventAction, eventName]);
			}
		} else {
			_paq.push(['trackEvent', eventCategory, eventAction]);
		}
	}

	trackGoal(goalID: number): void {
		if(isDevMode()) {
			console.log('tracking goal', goalID);
		}
		let _paq = (window as any)._paq || [];
		_paq.push(['trackGoal', goalID]);
	}

}
